import React from 'react';
import { applyStyles, downloadFile } from 'util/helpers';
import { css } from 'styled-components';
import { get, isNull } from 'lodash';

class Preview extends React.Component {
  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.location.search);
    const target = urlParams.get('target');

    switch (target) {
      case 'delete':
        window.close();
        break;
      case 'quotation':
        this.handleDownload(
          this.props.downloadQuotation(
            urlParams.get('voucherNum'),
            urlParams.get('deliveryNum'),
            urlParams.get('name')
          ),
          'quotation.pdf'
        );
        break;
      case 'receipt':
        this.handleDownload(
          this.props.downloadReceipt(
            urlParams.get('projectId'),
            urlParams.get('name')
          ),
          'receipt.pdf'
        );
        break;
      default:
        break;
    }
  }

  handleDownload(downloadApiRequest, filename) {
    downloadApiRequest
      .then(() => {
        let downloadURL = get(this.props, 'orderAggregatorsQuotation.url', null) || get(this.props, 'mypageReceipt.url', null)
        this.props.history.replace('/preview?target=delete')
        downloadFile(filename, downloadURL);
      })
      .catch(() => {
        let error = get(this.props, 'orderAggregatorsQuotation.error', null) || get(this.props, 'error', null)
        if (isNull(error)) {
          return
        }
        const { showAlert } = this.props;
        const reader = new FileReader();
        reader.onload = () => {
          return showAlert(JSON.parse(reader.result).message);
        };
        reader.readAsText(error.data);
      });
  }

  render() {
    const { className } = this.props;

    return <div className={className} onClick={ (event) => event.preventDefault() }/>;
  }
}

const commonStyle = css`
  position: fixed;
  top: 0;
  z-index: 999;
  background-color: #FFF;
  height: 100%;
  width: 100%;
  pointer-events: none;
`;

export default applyStyles(Preview)(commonStyle);



// WEBPACK FOOTER //
// ./src/components/Preview/index.js